import moment from 'moment';
import HelperMixin from '../../Shared/HelperMixin.vue';

export default {
    name: 'StockAvailability',
    mixins: [HelperMixin],

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails) {
            this.href('/Home');
            return;
        }
        // بلا بحث: أول ثلاثين صنفاً لها رصيد — الشاشة تبدأ مفيدة لا فارغة.
        this.searchProducts();
    },

    filters: {
        momentDate(date) {
            if (!date) return '—';
            return moment(date).format('DD/MM/YYYY');
        },
    },

    data() {
        return {
            search: '',
            products: [],
            loadingProducts: false,

            selectedProductId: null,
            availability: null,
            loadingAvailability: false,

            // مفاتيح المخازن المفتوحة لعرض تشغيلاتها
            expandedStores: [],
            showDepartmentStores: true,
        };
    },

    computed: {
        /**
         * مخازن الأقسام تُخفى افتراضياً لا لأنها غير مهمة، بل لأن رصيدها ليس متاحاً
         * لإعادة التوزيع بين الجهات — هو داخل عنبر يخدم مرضاه.
         */
        visibleFacilities() {
            const list = (this.availability && this.availability.facilities) || [];
            if (this.showDepartmentStores) return list;
            return list
                .map((f) => ({ ...f, stores: (f.stores || []).filter((s) => !s.isDepartmentStore) }))
                .filter((f) => f.stores.length);
        },
    },

    methods: {
        searchProducts() {
            this.loadingProducts = true;
            this.$http.GetAvailabilityProducts(this.search)
                .then((res) => {
                    this.loadingProducts = false;
                    this.products = (res && res.data && res.data.info) || [];
                })
                .catch(() => {
                    this.loadingProducts = false;
                    this.products = [];
                });
        },

        selectProduct(p) {
            if (!p || !p.productsId) return;
            this.selectedProductId = p.productsId;
            this.expandedStores = [];
            this.availability = null;
            this.loadingAvailability = true;

            this.$http.GetRecycleAvailability(p.productsId)
                .then((res) => {
                    this.loadingAvailability = false;
                    this.availability = (res && res.data) || null;
                })
                .catch((err) => {
                    this.loadingAvailability = false;
                    this.availability = null;
                    const msg = err.response && err.response.data ? err.response.data : 'تعذّر تحميل بيانات التوفر.';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },

        storeKey(branchesId, stockingId) {
            return `${branchesId || 0}:${stockingId}`;
        },

        toggleStore(key) {
            const i = this.expandedStores.indexOf(key);
            if (i >= 0) this.expandedStores.splice(i, 1);
            else this.expandedStores.push(key);
        },

        isStoreExpanded(key) {
            return this.expandedStores.indexOf(key) >= 0;
        },

        /** منتهية = أحمر · تنتهي خلال 90 يوماً = أصفر. نفس عتبة شاشات الصرف. */
        expiryClass(batch) {
            if (!batch) return '';
            if (batch.isExpired) return 'text-danger fw-semibold';
            if (batch.daysToExpiry != null && batch.daysToExpiry <= 90) return 'text-warning fw-semibold';
            return '';
        },

        expiryNote(batch) {
            if (!batch || !batch.expiryDate) return 'بلا تاريخ صلاحية';
            if (batch.isExpired) return 'منتهية';
            if (batch.daysToExpiry != null && batch.daysToExpiry <= 90) return `${batch.daysToExpiry} يوم`;
            return '';
        },
    },
};
